module.exports = __webpack_public_path__ + "media/images/athletes/1687-e7522572d190a8bdab4a489d88cb3e59.png";